import * as yup from 'yup';
import {
	getFormDefinition,
	useGovForm,
} from '@gov-design-system-ce/react-form-core';

export interface DataboxAdditionalSettingsFormData {
	[databoxId: string]: {
		shouldArchiveAutomatically?: boolean;
		shouldArchiveLargeMessagesAutomatically?: boolean;
	};
}

interface FormInstanceProps {
	databoxId: string;
}

export const FormInstance = ({ databoxId }: FormInstanceProps) => {
	const formSchema = yup
		.object({
			[databoxId]: yup.object({
				shouldArchiveAutomatically: yup.boolean(),
				shouldArchiveLargeMessagesAutomatically: yup.boolean(),
			}),
		})
		.required();

	const formMethods = useGovForm<DataboxAdditionalSettingsFormData>({
		formSchema,
		defaultValues: {
			[databoxId]: {
				shouldArchiveAutomatically: false,
				shouldArchiveLargeMessagesAutomatically: false,
			},
		},
	});

	return getFormDefinition({ formMethods, formSchema });
};
